import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HeroSection from "./components/sections/HeroSection";
import VisualHighlights from "./components/sections/VisualHighlights";
import CompanyIntro from "./components/sections/CompanyIntro";
import TrustedClients from "./components/sections/TrustedClients";
import VideoSection from "./components/sections/VideoSection";
import WhyProsafe from "./components/sections/WhyProsafe";
import MissionVision from "./components/sections/MissionVision";
import CoreValues from "./components/sections/CoreValues";
import CTASection from "./components/sections/CTASection";
import WhatsAppChat from "./components/common/WhatsAppChat";
import CookieBanner from "./components/common/CookieBanner";
import VacancyPopup from "./components/common/VacancyPopup";
import useSearchHighlight from "./hooks/useSearchHighlight";

// Lazy load pages for code splitting
const ContactPage = lazy(() => import("./pages/ContactPage"));
const ServicePage = lazy(() => import("./pages/ServicePage"));
const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
const VacaturesPage = lazy(() => import("./pages/VacaturesPage"));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-10 h-10 border-4 border-[#e21b1b] border-t-transparent rounded-full animate-spin" />
  </div>
);

const Home = () => {
  useSearchHighlight();
  
  return (
    <main className="min-h-screen">
      <Header />
      <HeroSection />
      <VisualHighlights />
      <CompanyIntro />
      <TrustedClients />
      <VideoSection />
      <WhyProsafe />
      <MissionVision />
      <CoreValues />
      <CTASection />
      <Footer />
      <WhatsAppChat />
      <CookieBanner />
      <VacancyPopup />
    </main>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/projecten" element={<ProjectsPage />} />
              <Route path="/vacatures" element={<VacaturesPage />} />
              <Route path="/diensten/brandblussystemen" element={<ServicePage serviceKey="brandblussystemen" />} />
              <Route path="/diensten/branddetectie" element={<ServicePage serviceKey="branddetectie" />} />
              <Route path="/diensten/onderhoud" element={<ServicePage serviceKey="onderhoud" />} />
              <Route path="/diensten/advies" element={<ServicePage serviceKey="advies" />} />
              <Route path="/diensten/noodverlichting" element={<ServicePage serviceKey="noodverlichting" />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
